module.exports = __webpack_public_path__ + "612739c8ae8b2a8967242e85c7624f60.jpg";